export default __webpack_public_path__ + "d0814100187472f35618e2b1a9c116f6.png";